module.exports = __webpack_public_path__ + "static/media/Rubik-Light.1dc94b26.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Light/Rubik-Light.ttf
// module id = 1299
// module chunks = 49